import { Component, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { TooltipDirective } from '@cloudfactorydk/ng2-tooltip-directive';
import { ProductService } from 'src/app/shared-lib/domains/product';
import { AppService } from 'src/app/shared/app.service';

@Component({
  selector: 'app-print-settings-labels',
  templateUrl: './print-settings-labels.component.html',
  styleUrls: ['./print-settings-labels.component.scss'],
  standalone: false
})
export class PrintSettingsLabelsComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('iconTooltip', { static: false }) iconTooltip: TooltipDirective;
  @ViewChildren('badgeTooltip') badgeTooltips: QueryList<TooltipDirective>;

  @Input() printSettings;
  @Input() files;
  @Input() size = 'normal';
  labels = [];

  constructor(public productService: ProductService, private appService: AppService) {
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked() {
    this.appService.registerTooltip(this.iconTooltip);
    this.badgeTooltips.forEach(tooltip => {
      this.appService.registerTooltip(tooltip);
    });
  }

  ngOnDestroy() {
    this.appService.unregisterTooltip(this.iconTooltip);
    this.badgeTooltips.forEach(t => {
      this.appService.unregisterTooltip(t);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.printSettings) {
      this.updateLabels();
    }
  }

  updateLabels() {
    this.labels = this.productService.getNewPrintLabels(this.printSettings, this.files);
  }

}

